import { render } from "./Footer1.vue?vue&type=template&id=269342e9&scoped=true"
const script = {}

import "./Footer1.vue?vue&type=style&index=0&id=269342e9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-269342e9"]])

export default __exports__